if (!customElements.get('ck-notify-inline')) {
  customElements.define(
    'ck-notify-inline',
    class CkNotifyInline extends HTMLElement {
      connectedCallback() {
        this.variantId = parseInt(this.dataset.variantId, 10);
        this.form = this.querySelector('[data-ck-notify-form]');
        this.emailInput = this.querySelector('[data-ck-notify-email]');
        this.submitBtn = this.querySelector('[data-ck-notify-submit]');
        this.errorEl = this.querySelector('[data-ck-notify-error]');
        this.successEl = this.querySelector('[data-ck-notify-success]');
        if (!this.submitBtn || !this.emailInput) return;

        this._boundSubmit = this._submit.bind(this);
        this._boundKeydown = this._onKeydown.bind(this);
        this.submitBtn.addEventListener('click', this._boundSubmit);
        this.emailInput.addEventListener('keydown', this._boundKeydown);
      }

      disconnectedCallback() {
        if (this.submitBtn && this._boundSubmit) {
          this.submitBtn.removeEventListener('click', this._boundSubmit);
        }
        if (this.emailInput && this._boundKeydown) {
          this.emailInput.removeEventListener('keydown', this._boundKeydown);
        }
      }

      _onKeydown(evt) {
        if (evt.key === 'Enter') {
          evt.preventDefault();
          this._submit();
        }
      }

      _submit() {
        if (this.errorEl) this.errorEl.hidden = true;

        if (!this.emailInput.checkValidity()) {
          this.emailInput.reportValidity();
          return;
        }

        if (!this.variantId || !window.theme || !theme.CkBackInStock) {
          if (this.errorEl) this.errorEl.hidden = false;
          return;
        }

        this.submitBtn.disabled = true;

        theme.CkBackInStock.subscribe(this.emailInput.value.trim(), this.variantId)
          .then(() => {
            if (this.form) this.form.hidden = true;
            if (this.successEl) this.successEl.hidden = false;
          })
          .catch(() => {
            this.submitBtn.disabled = false;
            if (this.errorEl) this.errorEl.hidden = false;
          });
      }
    }
  );
}
